import {useState} from "react";
import {BsShop} from "react-icons/bs";
export const BrandImage=({src,className})=>{
 const [failed,setFailed]=useState(null);
 if(!src || src===failed)return <BsShop className={className} role="img" aria-label="Logotipo de tienda no disponible" size={40}/>;
 return <img src={src} className={className} alt="Logotipo de la tienda" style={{objectFit:"contain",maxWidth:"100%",maxHeight:80}} onError={()=>setFailed(src)}/>;
};
